import tracksSagas from 'pages/history-page/store/lineups/tracks/sagas.js'

export default function sagas() {
  return [...tracksSagas()]
}
